import { useEffect } from "react";
import { useLocation, Link, NavLink } from "react-router-dom";

const ReservationSidebar = () => {
    const location = useLocation();
    const currentPath = location.pathname;


    const isPathActive = (path) => currentPath === path;

    const isPropertyDetailsActive = [
        "/Reservation/RateCode",
        "/Reservation/MealPlan",
        "/Reservation/RateInventory",
    ].some(path => currentPath.startsWith(path));

    const isBookingDetailsActive = [
        "/Reservation/NewBooking",
        "/Reservation/BookingList"
    ].some(path => currentPath.startsWith(path));

    const isAgentDetailsActive = ["/Reservation/NewAgent", "/Reservation/AgentList"].some(path => currentPath.startsWith(path));
    const isCompanyDetailsActive = ["/Reservation/NewCompany", "/Reservation/CompanyList"].some(path => currentPath.startsWith(path));

    const isMarketSegmentActive = ["/Reservation/MarketSegment"].some(path => currentPath.startsWith(path));
    const isBusinssSourceActive = ["/Reservation/BusinessSource"].some(path => currentPath.startsWith(path));

    const isGuaranteeCodesActive = ["/Reservation/GuaranteeCodes"].some(path => currentPath.startsWith(path));

    useEffect(() => {
        const wrapper = document.querySelector('.wrapper');
        if (wrapper && !wrapper.classList.contains('sidebar_minimize')) {
            wrapper.classList.add('sidebar_minimize');
        }
        const toggleSidebarBtn = document.querySelector('.toggle-sidebar');
        const sidenavTogglerBtn = document.querySelector('.sidenav-toggler');
        const sidebarElement = document.querySelector('.sidebar');

        const toggleSidebar = () => {
            if (wrapper) {
                wrapper.classList.toggle('sidebar_minimize');
            }
        };

        const handleMouseEnter = () => {
            if (wrapper && wrapper.classList.contains('sidebar_minimize')) {
                wrapper.classList.add('sidebar_minimize_hover');
            }
        };

        const handleMouseLeave = () => {
            if (wrapper) {
                wrapper.classList.remove('sidebar_minimize_hover');
            }
        };

        // Add click event listeners
        toggleSidebarBtn?.addEventListener('click', toggleSidebar);
        sidenavTogglerBtn?.addEventListener('click', toggleSidebar);

        // Hover effect
        sidebarElement?.addEventListener('mouseenter', handleMouseEnter);
        sidebarElement?.addEventListener('mouseleave', handleMouseLeave);

        // Cleanup on unmount
        return () => {
            toggleSidebarBtn?.removeEventListener('click', toggleSidebar);
            sidenavTogglerBtn?.removeEventListener('click', toggleSidebar);
            sidebarElement?.removeEventListener('mouseenter', handleMouseEnter);
            sidebarElement?.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);


    return (
        <div className="sidebar" data-background-color="dark">
            <div className="sidebar-logo">
                <div className="logo-header" data-background-color="dark">
                    <Link to="/" className="logo">
                        <img
                            src="../assets/img/BookOnNile Logo.svg"
                            alt="navbar brand"
                            className="navbar-brand"
                            style={{ backgroundColor: "#fff", padding: "4px", width: "60px", margin: "0 auto", height: "49px" }}
                        />
                    </Link>
                    <div className="nav-toggle">
                        <button className="btn btn-toggle toggle-sidebar"><i className="gg-menu-right" /></button>
                        <button className="btn btn-toggle sidenav-toggler"><i className="gg-menu-left" /></button>
                    </div>
                    <button className="topbar-toggler more"><i className="gg-more-vertical-alt" /></button>
                </div>
            </div>

            <div className="sidebar-wrapper scrollbar-inner">
                <div className="sidebar-content">
                    <ul className="nav nav-secondary">
                        <li className={isPathActive("/") ? "nav-item active" : "nav-item"}>
                            <NavLink to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <i className="fas fa-home" /><p>Home</p>
                            </NavLink>
                        </li>

                        <li className={isPathActive("/Reservation/Dashboard") ? "nav-item active" : "nav-item"}>
                            <NavLink to="/Reservation/Dashboard" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <i className="fas fa-tachometer-alt" /><p>Dashboard</p>
                            </NavLink>
                        </li>




                        {/* Property Details */}
                        <li className={`nav-item ${isPropertyDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#propertyDetails" aria-expanded={isPropertyDetailsActive}>
                                <i className="fas fa-building" /><p>Property Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isPropertyDetailsActive ? "show" : ""}`} id="propertyDetails">
                                <ul className="nav nav-collapse">

                                    <li className={isPathActive("/Reservation/RateCode") ? "active" : ""}>
                                        <NavLink to="/Reservation/RateCode" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Rate Code</span>
                                        </NavLink>
                                    </li>


                                    <li className={isPathActive("/Reservation/MealPlan/Property/MealPlanList") ? "active" : ""}>
                                        <NavLink to="/Reservation/MealPlan" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Meal Plan</span>
                                        </NavLink>
                                    </li>

                                    <li className={isPathActive("/Reservation/RateInventory") ? "active" : ""}>
                                        <NavLink to="/Reservation/RateInventory" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Rate Inventory</span>
                                        </NavLink>
                                    </li>

                                </ul>
                            </div>
                        </li>

                        {/* Booking Details */}
                        <li className={`nav-item ${isBookingDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#bookingDetails" aria-expanded={isBookingDetailsActive}>
                                <i className="fas fa-calendar-check" /><p>Booking Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isBookingDetailsActive ? "show" : ""}`} id="bookingDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Reservation/NewBooking") ? "active" : ""}>
                                        <NavLink to="/Reservation/NewBooking" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">New Booking</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Reservation/BookingList") ? "active" : ""}>
                                        <NavLink to="/Reservation/BookingList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Booking List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Agent Details */}
                        <li className={`nav-item ${isAgentDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#agentDetails" aria-expanded={isAgentDetailsActive}>
                                <i className="fas fa-user-tie" /><p>Agent Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isAgentDetailsActive ? "show" : ""}`} id="agentDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Reservation/NewAgent") ? "active" : ""}>
                                        <NavLink to="/Reservation/NewAgent" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">New Agent</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Reservation/AgentList") ? "active" : ""}>
                                        <NavLink to="/Reservation/AgentList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Agent List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Company Details */}
                        <li className={`nav-item ${isCompanyDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#companyDetails" aria-expanded={isCompanyDetailsActive}>
                                <i className="fas fa-building" /><p>Company Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isCompanyDetailsActive ? "show" : ""}`} id="companyDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Reservation/NewCompany") ? "active" : ""}>
                                        <NavLink to="/Reservation/NewCompany" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">New Company</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Reservation/CompanyList") ? "active" : ""}>
                                        <NavLink to="/Reservation/CompanyList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Company List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Market Segment */}
                        <li className={`nav-item ${isMarketSegmentActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#MarketSegmentDetails" aria-expanded={isMarketSegmentActive}>
                                <i className="fas fa-chart-line" /><p>Market Segment</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isMarketSegmentActive ? "show" : ""}`} id="MarketSegmentDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Reservation/MarketSegment") ? "active" : ""}>
                                        <NavLink to="/Reservation/MarketSegment" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Market Segment</span>
                                        </NavLink>
                                    </li>

                                </ul>
                            </div>
                        </li>

                        {/* Business Source */}
                        <li className={`nav-item ${isBusinssSourceActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#userDetails" aria-expanded={isBusinssSourceActive}>
                                <i className="fas fa-user" /><p>Business Source</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isBusinssSourceActive ? "show" : ""}`} id="userDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Reservation/BusinessSource") ? "active" : ""}>
                                        <NavLink to="/Reservation/BusinessSource" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Business Source</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className={`nav-item ${isGuaranteeCodesActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#guaranteeCodes" aria-expanded={isGuaranteeCodesActive}>
                                <i className="fas fa-user" /><p>Guarantee Codes</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isGuaranteeCodesActive ? "show" : ""}`} id="guaranteeCodes">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Reservation/GuaranteeCodes") ? "active" : ""}>
                                        <NavLink to="/Reservation/GuaranteeCodes" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Guarantee Codes</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>


                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ReservationSidebar;
